export default __webpack_public_path__ + "static/media/tick_thanks.b20c40c4.svg";